module.exports = __webpack_public_path__ + "img/access.45c55525.png";